import { Bell } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

interface UserNotificationProps {
  unreadNotifications: number
  className?: string
}

export const UserNotification = React.memo(function UserNotification({
  unreadNotifications,
  className,
}: UserNotificationProps) {
  const badgeDisplay = React.useMemo(() => {
    if (unreadNotifications <= 0) return null

    return (
      <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center -mt-1 -mr-1">
        {unreadNotifications > 9 ? '9+' : unreadNotifications}
      </span>
    )
  }, [unreadNotifications])

  return (
    <div
      className={cn(
        'relative mt-1 flex cursor-pointer flex-col items-center rounded-full p-1 transition-colors duration-200 hover:bg-gray-100 hover:text-gray-600 group',
        className
      )}
    >
      <Bell className="size-6" />
      {badgeDisplay}
    </div>
  )
})
